export const colors = {
  primary: '#DBD1AB',
  surface: '#0F1F2E',
  blue500: '#152B40',
  blue400: '#19344D',
  blue300: '#1E3E5A',
  blue200: '#234867',
  blue100: '#A3B5C7',
  blue50: '#E9EFF4',
  border: '#354C62',
  textWeak: '#ccd0d5',
};
